import { NextSeo } from "next-seo"
import { useRouter } from "next/router"

type Props = {
  title: string
  content?: string
  nofollow?: boolean
  noindex?: boolean
}

export default function CustomHead({
  title,
  content = "",
  nofollow = false,
  noindex = false,
}: Props) {
  const { pathname } = useRouter()

  function sanitizePathname(path: string): string {
    return path.replace(/\[+.*?\]+/g, "").replace(/\/+$/, "")
  }

  const sanitizedPathname = sanitizePathname(pathname)
  const pageURL = `${process.env.NEXT_PUBLIC_API_BASE_URL}${sanitizedPathname}`

  return (
    <NextSeo
      title={title}
      description={content}
      canonical={pageURL}
      nofollow={nofollow}
      noindex={noindex}
    />
  )
}
